<template>
  <menu-content-container
    :header="headerTitle"
    :border-full="containerBorder"
    :border-bottom="containerBorder"
    :margin-top="marginTop"
    :padding-left-right="paddingLeftRight"
  >
    <template #header-action>
      <t-input-toggle
        v-if="allowDirections"
        v-model="detailBorder"
        :label="$t('forms.independent_borders')"
      />
    </template>

    <transition name="slide-fade" mode="out-in">
      <div v-if="detailBorder && allowDirections" key="expanded">
        <content-row>
          <t-input-border
            :color="borderColorTop"
            :size="borderSizeTop"
            :border-style="borderStyleTop"
            :color-picker-top="colorPickerTop"
            :label="`${$t('forms.divider_border')} ${$t('forms.top')}`"
            :label-width="$t('forms.border_width')"
            :label-style="$t('forms.border_style')"
            :template-colors-label="$t('color_picker.template_colors')"
            :predefined-colors-label="$t('color_picker.predefined_colors')"
            :disabled="disabled"
            :light="generalStore.light"
            :colors="colors"
            :template-colors="templateColors"
            :changed-color="changedColorTop"
            :changed-size="changedSizeTop"
            :changed-style="changedStyleTop"
            @reset-color="resetDirectionSubvalue('top', 'color')"
            @reset-size="resetDirectionSubvalue('top', 'size')"
            @reset-style="resetDirectionSubvalue('top', 'style')"
            @color-changed="borderColorChangedTop"
            @size-changed="borderSizeTop = $event"
            @border-style-changed="borderStyleTop = $event"
            @get-template-colors="getAllColorsFromTemplate"
            @start-selecting-color="generalStore.colorSelecting = true"
            @stop-selecting-color="generalStore.colorSelecting = false"
          />
        </content-row>
        <content-row>
          <t-input-border
            :color="borderColorRight"
            :size="borderSizeRight"
            :border-style="borderStyleRight"
            :color-picker-top="colorPickerTop"
            :label="`${$t('forms.divider_border')} ${$t('forms.right')}`"
            :label-width="$t('forms.border_width')"
            :label-style="$t('forms.border_style')"
            :template-colors-label="$t('color_picker.template_colors')"
            :predefined-colors-label="$t('color_picker.predefined_colors')"
            :disabled="disabled"
            :light="generalStore.light"
            :colors="colors"
            :template-colors="templateColors"
            :changed-color="changedColorRight"
            :changed-size="changedSizeRight"
            :changed-style="changedStyleRight"
            @reset-color="resetDirectionSubvalue('right', 'color')"
            @reset-size="resetDirectionSubvalue('right', 'size')"
            @reset-style="resetDirectionSubvalue('right', 'style')"
            @color-changed="borderColorChangedRight"
            @size-changed="borderSizeRight = $event"
            @border-style-changed="borderStyleRight = $event"
            @get-template-colors="getAllColorsFromTemplate"
            @start-selecting-color="generalStore.colorSelecting = true"
            @stop-selecting-color="generalStore.colorSelecting = false"
          />
        </content-row>
        <content-row>
          <t-input-border
            :color="borderColorBottom"
            :size="borderSizeBottom"
            :border-style="borderStyleBottom"
            :color-picker-top="colorPickerTop"
            :label="`${$t('forms.divider_border')} ${$t('forms.bottom')}`"
            :label-width="$t('forms.border_width')"
            :label-style="$t('forms.border_style')"
            :template-colors-label="$t('color_picker.template_colors')"
            :predefined-colors-label="$t('color_picker.predefined_colors')"
            :disabled="disabled"
            :light="generalStore.light"
            :colors="colors"
            :template-colors="templateColors"
            :changed-color="changedColorBottom"
            :changed-size="changedSizeBottom"
            :changed-style="changedStyleBottom"
            @reset-color="resetDirectionSubvalue('bottom', 'color')"
            @reset-size="resetDirectionSubvalue('bottom', 'size')"
            @reset-style="resetDirectionSubvalue('bottom', 'style')"
            @color-changed="borderColorChangedBottom"
            @size-changed="borderSizeBottom = $event"
            @border-style-changed="borderStyleBottom = $event"
            @get-template-colors="getAllColorsFromTemplate"
            @start-selecting-color="generalStore.colorSelecting = true"
            @stop-selecting-color="generalStore.colorSelecting = false"
          />
        </content-row>
        <content-row>
          <t-input-border
            :color="borderColorLeft"
            :size="borderSizeLeft"
            :border-style="borderStyleLeft"
            :color-picker-top="colorPickerTop"
            :label="`${$t('forms.divider_border')} ${$t('forms.left')}`"
            :label-width="$t('forms.border_width')"
            :label-style="$t('forms.border_style')"
            :template-colors-label="$t('color_picker.template_colors')"
            :predefined-colors-label="$t('color_picker.predefined_colors')"
            :disabled="disabled"
            :light="generalStore.light"
            :colors="colors"
            :template-colors="templateColors"
            :changed-color="changedColorLeft"
            :changed-size="changedSizeLeft"
            :changed-style="changedStyleLeft"
            @reset-color="resetDirectionSubvalue('left', 'color')"
            @reset-size="resetDirectionSubvalue('left', 'size')"
            @reset-style="resetDirectionSubvalue('left', 'style')"
            @color-changed="borderColorChangedLeft"
            @size-changed="borderSizeLeft = $event"
            @border-style-changed="borderStyleLeft = $event"
            @get-template-colors="getAllColorsFromTemplate"
            @start-selecting-color="generalStore.colorSelecting = true"
            @stop-selecting-color="generalStore.colorSelecting = false"
          />
        </content-row>
      </div>

      <div v-else key="closed">
        <t-input-border
          :color="borderColor"
          :size="borderSize"
          :border-style="borderStyle"
          :color-picker-top="colorPickerTop"
          :label="label ? label : $t('forms.divider_border')"
          :label-width="$t('forms.border_width')"
          :label-style="$t('forms.border_style')"
          :template-colors-label="$t('color_picker.template_colors')"
          :predefined-colors-label="$t('color_picker.predefined_colors')"
          :disabled="disabled"
          :light="generalStore.light"
          :colors="colors"
          :template-colors="templateColors"
          :changed-color="changedColor"
          :changed-size="changedSize"
          :changed-style="changedStyle"
          @reset="emits('reset')"
          @reset-color="resetSubvalue('color')"
          @reset-size="resetSubvalue('size')"
          @reset-style="resetSubvalue('style')"
          @color-changed="borderColorChanged"
          @size-changed="borderSize = $event"
          @border-style-changed="borderStyle = $event"
          @get-template-colors="getAllColorsFromTemplate"
          @start-selecting-color="generalStore.colorSelecting = true"
          @stop-selecting-color="generalStore.colorSelecting = false"
        />
      </div>
    </transition>
    <slot />
  </menu-content-container>
</template>

<script lang="ts" setup>
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { useColorsStore } from "@/stores/colors";
  import { useGeneralStore } from "@/stores/generalStore";
  import { TInputBorder, TInputToggle } from "@topol/twig-ui";
  import { ref, computed, onMounted, watch } from "vue";

  const props = defineProps({
    headerTitle: {
      type: String,
      required: false,
      default: undefined,
    },
    border: {
      type: String,
      required: false,
      default: undefined,
    },
    borderRight: {
      type: String,
      required: false,
      default: undefined,
    },
    borderLeft: {
      type: String,
      required: false,
      default: undefined,
    },
    borderTop: {
      type: String,
      required: false,
      default: undefined,
    },
    borderBottom: {
      type: String,
      required: false,
      default: undefined,
    },
    allowDirections: {
      type: Boolean,
      default: true,
    },
    colorPickerTop: {
      type: Boolean,
      default: false,
    },
    marginTop: {
      type: Number,
      default: 12,
    },
    paddingLeftRight: {
      type: Number,
      default: 10,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: undefined,
    },
    changed: {
      type: Boolean,
      default: false,
    },
    defaultBorder: {
      type: String,
      default: undefined,
    },
    defaultBorderTop: {
      type: String,
      default: undefined,
    },
    defaultBorderRight: {
      type: String,
      default: undefined,
    },
    defaultBorderBottom: {
      type: String,
      default: undefined,
    },
    defaultBorderLeft: {
      type: String,
      default: undefined,
    },
    changedTop: {
      type: Boolean,
      default: false,
    },
    changedRight: {
      type: Boolean,
      default: false,
    },
    changedBottom: {
      type: Boolean,
      default: false,
    },
    changedLeft: {
      type: Boolean,
      default: false,
    },
    containerBorder: {
      type: Boolean,
      default: true,
    },
  });

  const emits = defineEmits([
    "borderChanged",
    "reset",
    "resetTop",
    "resetRight",
    "resetBottom",
    "resetLeft",
  ]);

  const mjmlStore = useMjmlStore();
  const colorsStore = useColorsStore();
  const generalStore = useGeneralStore();

  const detailBorder = ref(false);
  const bRight = ref(
    props.borderRight || ("0px #000000 none" as string | undefined)
  );
  const bLeft = ref(
    props.borderLeft || ("0px #000000 none" as string | undefined)
  );
  const bTop = ref(
    props.borderTop || ("0px #000000 none" as string | undefined)
  );
  const bBottom = ref(
    props.borderBottom || ("0px #000000 none" as string | undefined)
  );
  const templateColors = ref<string[]>([]);

  // --- Per-subvalue changed/reset ---
  function parseBorderParts(val: string | undefined) {
    if (!val || val === "none") {
      return { size: 0, color: "#000000", style: "none" };
    }
    return {
      size: parseInt(getBorderAttr(val, "size")) || 0,
      color: getBorderAttr(val, "color") || "#000000",
      style: getBorderAttr(val, "style") || "none",
    };
  }

  // Main border
  const defaultParts = computed(() => parseBorderParts(props.defaultBorder));

  const changedColor = computed(
    () => borderColor.value !== defaultParts.value.color
  );
  const changedSize = computed(
    () => borderSize.value !== defaultParts.value.size
  );
  const changedStyle = computed(
    () => borderStyle.value !== defaultParts.value.style
  );

  function resetSubvalue(part: "color" | "size" | "style") {
    const def = defaultParts.value;
    const s = part === "size" ? def.size : borderSize.value;
    const c = part === "color" ? def.color : borderColor.value;
    const st = part === "style" ? def.style : borderStyle.value;
    emits("borderChanged", { border: `${s}px ${c} ${st}` });
  }

  // Per-direction
  const defaultPartsTop = computed(() =>
    parseBorderParts(props.defaultBorderTop)
  );
  const defaultPartsRight = computed(() =>
    parseBorderParts(props.defaultBorderRight)
  );
  const defaultPartsBottom = computed(() =>
    parseBorderParts(props.defaultBorderBottom)
  );
  const defaultPartsLeft = computed(() =>
    parseBorderParts(props.defaultBorderLeft)
  );

  const changedColorTop = computed(
    () => borderColorTop.value !== defaultPartsTop.value.color
  );
  const changedSizeTop = computed(
    () => borderSizeTop.value !== defaultPartsTop.value.size
  );
  const changedStyleTop = computed(
    () => borderStyleTop.value !== defaultPartsTop.value.style
  );

  const changedColorRight = computed(
    () => borderColorRight.value !== defaultPartsRight.value.color
  );
  const changedSizeRight = computed(
    () => borderSizeRight.value !== defaultPartsRight.value.size
  );
  const changedStyleRight = computed(
    () => borderStyleRight.value !== defaultPartsRight.value.style
  );

  const changedColorBottom = computed(
    () => borderColorBottom.value !== defaultPartsBottom.value.color
  );
  const changedSizeBottom = computed(
    () => borderSizeBottom.value !== defaultPartsBottom.value.size
  );
  const changedStyleBottom = computed(
    () => borderStyleBottom.value !== defaultPartsBottom.value.style
  );

  const changedColorLeft = computed(
    () => borderColorLeft.value !== defaultPartsLeft.value.color
  );
  const changedSizeLeft = computed(
    () => borderSizeLeft.value !== defaultPartsLeft.value.size
  );
  const changedStyleLeft = computed(
    () => borderStyleLeft.value !== defaultPartsLeft.value.style
  );

  function resetDirectionSubvalue(
    direction: "top" | "right" | "bottom" | "left",
    part: "color" | "size" | "style"
  ) {
    const defMap = {
      top: defaultPartsTop,
      right: defaultPartsRight,
      bottom: defaultPartsBottom,
      left: defaultPartsLeft,
    };
    const sizeMap = {
      top: borderSizeTop,
      right: borderSizeRight,
      bottom: borderSizeBottom,
      left: borderSizeLeft,
    };
    const colorMap = {
      top: borderColorTop,
      right: borderColorRight,
      bottom: borderColorBottom,
      left: borderColorLeft,
    };
    const styleMap = {
      top: borderStyleTop,
      right: borderStyleRight,
      bottom: borderStyleBottom,
      left: borderStyleLeft,
    };
    const refMap = { top: bTop, right: bRight, bottom: bBottom, left: bLeft };

    const def = defMap[direction].value;
    const s = part === "size" ? def.size : sizeMap[direction].value;
    const c = part === "color" ? def.color : colorMap[direction].value;
    const st = part === "style" ? def.style : styleMap[direction].value;

    refMap[direction].value = `${s}px ${c} ${st}`;
    emits("borderChanged", {
      border: refMap[direction].value,
      borderType: `border-${direction}`,
    });
  }

  const borderSize = computed({
    get() {
      if (props.border && props.border !== "none") {
        return parseInt(getBorderAttr(props.border, "size"));
      }
      return 0;
    },
    set(val: number) {
      if (val === undefined || val === null) {
        val = 0;
      }

      if (val !== borderSize.value) {
        emits("borderChanged", {
          border: `${val}px ${borderColor.value} ${borderStyle.value}`,
        });
      }
    },
  });

  const borderColor = computed(() => {
    if (props.border && props.border !== "none") {
      return getBorderAttr(props.border, "color");
    }
    return "#000000";
  });

  const borderStyle = computed({
    get() {
      if (props.border && props.border !== "none") {
        return getBorderAttr(props.border, "style");
      }
      return "none";
    },
    set(val = "solid") {
      emits("borderChanged", {
        border: `${borderSize.value}px ${borderColor.value} ${val}`,
      });
    },
  });

  const borderSizeTop = computed({
    get() {
      if (bTop.value && bTop.value !== "none") {
        return parseInt(getBorderAttr(bTop.value, "size"));
      }
      return 0;
    },
    set(val = 0) {
      //@ts-expect-error
      // Error because keeping legacy string working as well together with number
      if (val === undefined || val === null || val === "") {
        val = 0;
      }

      if (val !== borderSizeTop.value) {
        bTop.value = `${val}px ${borderColorTop.value} ${borderStyleTop.value}`;

        emits("borderChanged", {
          border: bTop.value,
          borderType: "border-top",
        });
      }
    },
  });

  const borderColorTop = computed(() => {
    if (bTop.value) {
      return getBorderAttr(bTop.value, "color");
    }
    return "#000000";
  });

  const borderStyleTop = computed({
    get() {
      if (bTop.value && bTop.value !== "none") {
        return getBorderAttr(bTop.value, "style");
      }
      return "solid";
    },
    set(val = "solid") {
      bTop.value = `${borderSizeTop.value}px ${borderColorTop.value} ${val}`;

      emits("borderChanged", {
        border: bTop.value,
        borderType: "border-top",
      });
    },
  });

  const borderSizeBottom = computed({
    get() {
      if (bBottom.value && bBottom.value !== "none") {
        return parseInt(getBorderAttr(bBottom.value, "size"));
      }
      return 0;
    },
    set(val = 0) {
      //@ts-expect-error
      // Error because keeping legacy string working as well together with number
      if (val === undefined || val === null || val === "") {
        val = 0;
      }

      if (val !== borderSizeBottom.value) {
        bBottom.value = `${val}px ${borderColorBottom.value} ${borderStyleBottom.value}`;

        emits("borderChanged", {
          border: bBottom.value,
          borderType: "border-bottom",
        });
      }
    },
  });

  const borderColorBottom = computed(() => {
    if (bBottom.value) {
      return getBorderAttr(bBottom.value, "color");
    }
    return "#000000";
  });

  const borderStyleBottom = computed({
    get() {
      if (bBottom.value && bBottom.value !== "none") {
        return getBorderAttr(bBottom.value, "style");
      }
      return "solid";
    },
    set(val = "solid") {
      bBottom.value = `${borderSizeBottom.value}px ${borderColorBottom.value} ${val}`;

      emits("borderChanged", {
        border: bBottom.value,
        borderType: "border-bottom",
      });
    },
  });

  const borderSizeRight = computed({
    get() {
      if (bRight.value && bRight.value !== "none") {
        return parseInt(getBorderAttr(bRight.value, "size"));
      }
      return 0;
    },
    set(val = 0) {
      //@ts-expect-error
      // Error because keeping legacy string working as well together with number
      if (val === undefined || val === null || val === "") {
        val = 0;
      }

      if (val !== borderSizeRight.value) {
        bRight.value = `${val}px ${borderColorRight.value} ${borderStyleRight.value}`;

        emits("borderChanged", {
          border: bRight.value,
          borderType: "border-right",
        });
      }
    },
  });

  const borderColorRight = computed(() => {
    if (bRight.value) {
      return getBorderAttr(bRight.value, "color");
    }
    return "#000000";
  });

  const borderStyleRight = computed({
    get() {
      if (bRight.value && bRight.value !== "none") {
        return getBorderAttr(bRight.value, "style");
      }
      return "solid";
    },
    set(val = "solid") {
      bRight.value = `${borderSizeRight.value}px ${borderColorRight.value} ${val}`;

      emits("borderChanged", {
        border: bRight.value,
        borderType: "border-right",
      });
    },
  });

  const borderSizeLeft = computed({
    get() {
      if (bLeft.value && bLeft.value !== "none") {
        return parseInt(getBorderAttr(bLeft.value, "size"));
      }
      return 0;
    },
    set(val = 0) {
      //@ts-expect-error
      // Error because keeping legacy string working as well together with number
      if (val === undefined || val === null || val === "") {
        val = 0;
      }

      if (val !== borderSizeLeft.value) {
        bLeft.value = `${val}px ${borderColorLeft.value} ${borderStyleLeft.value}`;

        emits("borderChanged", {
          border: bLeft.value,
          borderType: "border-left",
        });
      }
    },
  });

  const borderColorLeft = computed(() => {
    if (bLeft.value) {
      return getBorderAttr(bLeft.value, "color");
    }
    return "#000000";
  });

  const borderStyleLeft = computed({
    get() {
      if (bLeft.value && bLeft.value !== "none") {
        return getBorderAttr(bLeft.value, "style");
      }
      return "solid";
    },
    set(val = "solid") {
      bLeft.value = `${borderSizeLeft.value}px ${borderColorLeft.value} ${val}`;

      emits("borderChanged", {
        border: bLeft.value,
        borderType: "border-left",
      });
    },
  });

  const colors = computed(() => colorsStore.colors);

  function getAllColorsFromTemplate() {
    const templateString = JSON.stringify(mjmlStore.getMjml()).toLowerCase();
    const hexColorPattern = /#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})/g;
    const colors = templateString.match(hexColorPattern);
    // templateColors.value = [...new Set(colors)];
  }

  function getBorderAttr(border: string, attr: "size" | "color" | "style") {
    if (border !== "none" && border !== undefined) {
      const attrIndex = convertAttrToArrayIndex(attr);
      const splitBorder = border.split(" ");
      return splitBorder[attrIndex];
    }

    return "";
  }

  function convertAttrToArrayIndex(attr: "size" | "color" | "style"): number {
    if (attr === "size") {
      return 0;
    } else if (attr === "color") {
      return 1;
    } else if (attr === "style") {
      return 2;
    } else {
      throw Error('attr must be "size", "color" or "style"');
    }
  }

  function hideDetailBorder() {
    bRight.value = undefined;
    bLeft.value = undefined;
    bTop.value = undefined;
    bBottom.value = undefined;

    detailBorder.value = false;

    emits("borderChanged", {
      border: undefined,
      borderType: "border-right",
    });

    emits("borderChanged", {
      border: undefined,
      borderType: "border-top",
    });

    emits("borderChanged", {
      border: undefined,
      borderType: "border-left",
    });

    emits("borderChanged", {
      border: undefined,
      borderType: "border-bottom",
    });
  }

  function showDetailBorder() {
    detailBorder.value = true;

    //init borders from existing border return if border is not set
    if (!props.border) {
      return;
    }

    bRight.value = props.border;
    emits("borderChanged", {
      border: bRight.value,
      borderType: "border-right",
    });

    bTop.value = props.border;
    emits("borderChanged", {
      border: bTop.value,
      borderType: "border-top",
    });

    bLeft.value = props.border;
    emits("borderChanged", {
      border: bLeft.value,
      borderType: "border-left",
    });

    bBottom.value = props.border;
    emits("borderChanged", {
      border: bBottom.value,
      borderType: "border-bottom",
    });
  }

  function borderColorChanged(newColor = "#000000") {
    emits("borderChanged", {
      border: `${borderSize.value}px ${newColor} ${borderStyle.value}`,
    });
  }

  function borderColorChangedTop(newColor = "#000000") {
    bTop.value = `${borderSizeTop.value}px ${newColor} ${borderStyleTop.value}`;

    emits("borderChanged", {
      border: bTop.value,
      borderType: "border-top",
    });
  }

  function borderColorChangedBottom(newColor = "#000000") {
    bBottom.value = `${borderSizeBottom.value}px ${newColor} ${borderStyleBottom.value}`;

    emits("borderChanged", {
      border: bBottom.value,
      borderType: "border-bottom",
    });
  }

  function borderColorChangedRight(newColor = "#000000") {
    bRight.value = `${borderSizeRight.value}px ${newColor} ${borderStyleRight.value}`;

    emits("borderChanged", {
      border: bRight.value,
      borderType: "border-right",
    });
  }

  function borderColorChangedLeft(newColor = "#000000") {
    bLeft.value = `${borderSizeLeft.value}px ${newColor} ${borderStyleLeft.value}`;

    emits("borderChanged", {
      border: bLeft.value,
      borderType: "border-left",
    });
  }

  function hasBorders() {
    if (
      props.borderRight != null &&
      props.borderRight !== "" &&
      props.borderLeft != null &&
      props.borderLeft !== "" &&
      props.borderTop != null &&
      props.borderTop !== "" &&
      props.borderBottom != null &&
      props.borderBottom !== ""
    ) {
      return true;
    }

    return false;
  }

  watch(
    () => props.borderTop,
    (val) => {
      bTop.value = val || "0px #000000 none";
    }
  );

  watch(
    () => props.borderBottom,
    (val) => {
      bBottom.value = val || "0px #000000 none";
    }
  );

  watch(
    () => props.borderLeft,
    (val) => {
      bLeft.value = val || "0px #000000 none";
    }
  );

  watch(
    () => props.borderRight,
    (val) => {
      bRight.value = val || "0px #000000 none";
    }
  );

  watch(detailBorder, (newVal) => {
    if (newVal === false) {
      hideDetailBorder();
    } else {
      showDetailBorder();
    }
  });

  onMounted(() => {
    detailBorder.value = hasBorders();

    if (detailBorder.value) {
      emits("borderChanged", {
        border: undefined,
        borderType: "border",
      });
    }
  });
</script>

<style scoped>
  .slide-fade-enter-active {
    transition: all 0.3s ease-in-out;
  }

  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateY(-5px);
    opacity: 0;
  }
</style>
